import DeskMenu from "./DeskMenu";
import DeskActivity from "./DeskActivity";

function PanelDesk() {
  return (
    <div className="max-md:hidden px-4 md:w-1/6 h-full bg-white shadow-md rounded-md">
      <DeskMenu disabled={true} />
      <DeskActivity disabled={true} />
    </div>
  );
}

export default PanelDesk;
